import React from 'react';

const DrawerLoading = () => (
  <div className='drawer'>
    <div className='drawer__pager'>
      <div className='drawer__inner' />
    </div>
  </div>
);

export default DrawerLoading;



// WEBPACK FOOTER //
// ./app/javascript/mastodon/features/ui/components/drawer_loading.js